import moment from 'moment';
import { getGetInspectionDetailQueryKey, useUpdateInspection, } from '../../../services/api/generated/client';
import { queryClient } from '../../../services/api/query/queryClient';
import { CLOSED } from '../../../constants/statuses';
const useUpdateInspectionStatusUseCase = (inspection, onSuccess) => {
    const updateInspection = useUpdateInspection({
        mutation: {
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: getGetInspectionDetailQueryKey(inspection.id),
                });
            },
        },
    });
    const execute = (values, helpers) => {
        const isComplete = +values.statusId === CLOSED;
        const completedDate = isComplete ? moment().utc().format() : null;
        helpers.setSubmitting(true);
        updateInspection.mutate({
            inspectionId: inspection.id,
            data: {
                completed_date: completedDate,
                status_id: +values.statusId,
            },
        }, {
            onSuccess: () => {
                onSuccess();
            },
            onSettled: () => {
                helpers.setSubmitting(false);
            },
        });
    };
    return {
        execute,
        isError: updateInspection.isError,
        error: updateInspection.error,
    };
};
export default useUpdateInspectionStatusUseCase;
